import type { FC } from 'react';
import React from 'react';
import type { Root } from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import IconError from '~/images/common/icons/error.svg';
import IconOk from '~/images/common/icons/success.svg';
import IconWarn from '~/images/common/icons/warn.svg';
import IconInfo from '~/images/common/icons/info.svg';

interface ToastProps {
  msg: string;
  icon: string;
}

export const Index: FC<ToastProps> = ({ msg, icon }) => (
  <div id="toast" className="m-toast">
    <div className="m-toast__wrap">
      <div className="m-toast__icon-wrap"><img width={30} height={30} src={icon} className="m-toast__icon" alt='' /></div>
      <p className="m-toast__text">{msg}</p>
    </div>
  </div>
);

export const useToast = () => {
  let timer: any = null;
  let root: Root;
  const startTimer = (time = 2000) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      root.render(<></>);
    }, time);
  };
  const showToast = (msg: string, icon: string) => {
    const box = document.getElementById('toastBox') as HTMLElement;
    if (!root) {
      root = createRoot(box);
    }
    root.render(<React.StrictMode>
      <Index msg={msg} icon={icon} />
    </React.StrictMode>,);
    startTimer();
  };

  const success = (msg: string) => {
    showToast(msg, IconOk);
  };

  const warn = (msg: string) => {
    showToast(msg, IconWarn);
  };

  const error = (msg: string) => {
    showToast(msg, IconError);
  };

  const info = (msg: string) => {
    showToast(msg, IconInfo);
  };

  return { success, warn, error, info };
};
